'use client'
import { useTranslate } from '@repo/shared/hooks'
import { Card, Col, Row, Typography } from '@repo/ui/components'
import { useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import { QuickKycForm } from './quick-kyc.form'
import { QuickKycSuccess } from './quick-kyc.success'
import { QuickKycLoading } from './quick-kyc.loading'
import { ButtonLink } from '@repo/shared/components'
import { useUserAuthDetails } from '@repo/services'
import { useRouter } from '@repo/shared/i18n/navigation'

export const QuickKycContainer = () => {
  const { t } = useTranslate()
  const [isSuccess, setIsSuccess] = useState(false)
  const searchParams = useSearchParams()
  const mobileOrEmail = searchParams.get('mobileOrEmail') ?? ''
  const isConfirmed = searchParams.get('confirmed') ?? ''
  const { replace } = useRouter()

  const { data: authDetails, isPending } = useUserAuthDetails()
  const hasKyc = authDetails?.data?.details?.kyc

  useEffect(() => {
    if (isConfirmed) {
      setIsSuccess(true)
    }
  }, [isConfirmed])

  // Check if user has completed KYC and redirect
  useEffect(() => {
    if (!isConfirmed && !isPending && hasKyc) {
      replace('/profile/account')
    }
  }, [hasKyc, isPending, replace, isConfirmed])

  // Show skeleton while loading
  if (!isConfirmed && (hasKyc || isPending)) {
    return <QuickKycLoading />
  }

  if (isSuccess) {
    return (
      <div className='px-md'>
        <QuickKycSuccess mobileOrEmail={mobileOrEmail} />
      </div>
    )
  }

  return (
    <div className='px-md'>
      <Card className='p-xl rounded-sm'>
        <Col className='gap-3xl'>
          <Row className='justify-between'>
            <Typography size='2xl' weight='bold'>
              {t('quickKyc_title')}
            </Typography>
            <Row className='gap-xs w-fit'>
              <ButtonLink size='sm' href='/dashboard'>
                {t('common_later')}
              </ButtonLink>
            </Row>
          </Row>
          <QuickKycForm
            onSuccess={() => setIsSuccess(true)}
            mobileOrEmail={mobileOrEmail}
          />
        </Col>
      </Card>
    </div>
  )
}
